import { useQuery } from "@tanstack/react-query";
import { getChannelStats } from "services/dashboard.service";

// period: 7d | 14d | 30d | 60d | 90d (default 30d)
export const useChannelStats = (period = "30d", options = {}) => {
  return useQuery({
    queryKey: ["channel-stats", period],
    queryFn: () => getChannelStats(period),
    select: (res) => res?.data,
    ...options,
  });
};
